import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Employee } from '../shared/model/employee.model';

export class WebAPIResult {
    StatusCode: number;
    Success: number;
    Msg: string = "";
    Privs: string = "";
}

export class APIResult {
    Success: number;
    Msg: string;
    Data: any;

    constructor() {
    }

    public static CreateAPIResult(Success: number, Msg: string) {
        var r = new APIResult();
        r.Success = Success;
        r.Msg = Msg;
        return r;
    }

    public get Succeeded(): boolean {
        return (this.Success == 1);
    }

    public get notifyType(): string {
        switch (this.Success) {
            case 0: return "error";
            case 1: return "success";
            case 2: return "warning";
            case 3:
            default: return "info";
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {
    constructor(private http: HttpClient, private auth: AuthorizeService) {
        console.log("Starting Employee Auth Service");
    }

    public ValidateEmployeePin(employeeUID: string, pin: string): Observable<boolean> {
        return this.http.get<WebAPIResult>('/api/Employee/Login/pin/' + employeeUID + '/' + pin).pipe(
          take(1),
          tap((d) => {
            // console.log("Validate Employee PIN");
            // console.log(d);
            this.auth.privString = d.Privs; // This will also update the NavigationService which handles the menus
          }),
          catchError((e) => {
            // console.log("Validate Employee Pin Error");
            // console.log(e);
            return EMPTY;
          }),
          map((m) => {
            // console.log("Employee Pin Validated ");
            // console.log(m);
            return m.Success == 1;
          })
        );
    }

    RecordEmployeeLogin(EmployeeId: number, BranchId: number, TerminalId: number) {
        return this.http
          .get<WebAPIResult>(
            '/api/Employee/RegisterLogin/' +
              EmployeeId.toString() +
              '/' +
              BranchId.toString() +
              '/' +
              TerminalId.toString()
          )
          .pipe(
            take(1),
            catchError((e) => {
              return EMPTY;
            }),
            map((m) => {
              return m.Success == 1;
            })
          );
    }

    public EmployeeLogout(employeeId: number, branchId: number, terminalId: number): Observable<boolean> {
        return this.http
          .get(
            '/api/Employee/Logout/' + employeeId.toString() + '/' + branchId.toString() + '/' + terminalId.toString()
          )
          .pipe(
            take(1),
            tap((d) => {
              this.auth.privString = '';
            }),
            catchError((e) => {
              // console.log("Employee Logout Error");
              // console.log(e);
              return EMPTY;
            }),
            map((m) => {
              // console.log("Employee Logout");
              return true;
            })
          );
    }

    public UpdateEmployee(employee: Employee): Observable<APIResult> {

        var data = {
            Uid: employee.UID,
            Title: employee.Title,
            FirstName: employee.FirstName,
            LastName: employee.LastName,
            EmailAddress: employee.EmailAddress,
            MobileTelephone: employee.MobileTelephone,
            ChangePassword1: employee.ChangePassword1,
            ChangePassword2: employee.ChangePassword2,
            ChangePIN1: employee.ChangePIN1,
            ChangePIN2: employee.ChangePIN2,
        };
        return this.http.post<WebAPIResult>('/api/Employee/Update', data).pipe(
          take(1),
          // tap(d => {
          //     console.log("Update Employee Profile Result");
          //     console.log(d);
          // }),
          catchError((e) => {
            // console.log("Employee Update  Error");
            // console.log(e);
            var result: APIResult = new APIResult();
            result.Success = 0;
            result.Msg = e; // "There was an error updating the employee profile";
            return of(result);
          }),
          map((m) => {
            // console.log("Employee Update Completed");
            var result: APIResult = new APIResult();
            result.Success = m.Success;
            result.Msg = m.Msg;
            return result;
          })
        );
    }

    public ValidateNewUserEmail(email: string, employeeId: number): Observable<APIResult> {
        var data = {
            email: email,
            employeeId: employeeId,
        }
        return this.http.post<WebAPIResult>('/api/Employee/ValidateNewUserEmail', data).pipe(
          take(1),
          catchError((e) => {
            var result: APIResult = new APIResult();
            result.Success = 0;
            result.Msg = e; // "There was an error updating the employee profile";
            return of(result);
          }),
          map((m) => {
            var result: APIResult = new APIResult();
            result.Success = m.Success;
            result.Msg = m.Msg;
            return result;
          })
        );
    }

    public ResetEmployeePassword(EmployeeId: number): Observable<APIResult> {
        var data = {
            EmployeeId: EmployeeId
        }
        return this.http.post<WebAPIResult>('/api/BackOffice/Employees/ResetEmployeePassword', data).pipe(
          take(1),
          catchError((e) => {
            // console.log("Reset Employee Password  Error");
            // console.log(e);
            var result: APIResult = new APIResult();
            result.Success = 0;
            result.Msg = e; // "There was an error updating the employee profile";
            return of(result);
          }),
          map((m) => {
            var result: APIResult = new APIResult();
            result.Success = m.Success;
            result.Msg = m.Msg;
            return result;
          })
        );
    }

    public ResetEmployeePIN(EmployeeId: number): Observable<APIResult> {
        var data = {
            EmployeeId: EmployeeId
        }
        return this.http.post<WebAPIResult>('/api/BackOffice/Employees/ResetEmployeePIN', data).pipe(
          take(1),
          catchError((e) => {
            // console.log("Reset Employee PIN Error");
            // console.log(e);
            var result: APIResult = new APIResult();
            result.Success = 0;
            result.Msg = e; // "There was an error updating the employee profile";
            return of(result);
          }),
          map((m) => {
            var result: APIResult = new APIResult();
            result.Success = m.Success;
            result.Msg = m.Msg;
            return result;
          })
        );
    }
}